module.exports = {"id":"222041","name":"Lucas Boyé","rating":"72","photo":"./data/images/photos/3/222041.png","club":{"name":"Celta Vigo","logo":"./data/images/clubs/CeltaVigo.png"},"positions":["BU","AG","MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LucasBoye0.json
// module id = 2566
// module chunks = 0